module.exports = __webpack_public_path__ + "img/ic-pprev.cc0ecd35.svg";